import { Component, Input, OnInit } from "@angular/core";
import "./vertical-map-layout.component.scss";

@Component({
    selector: "vertical-map-layout",
    template: require("./vertical-map-layout.component.html")
})
export class VerticalMapLayoutComponent implements OnInit {

    @Input() loading: boolean;

    constructor() { }

    ngOnInit(): void {

    }
}
